import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: column;
  padding: 2rem 2rem;

  background-color: var(--color-primaryDark);
  color: var(--color-primaryLightCompliment);

  @media only screen and (min-width: 1024px) {
    display: none;
  }
`

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
`

export const LinksDiv = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-flow: column;
  border-bottom: 1px solid var(--color-secondary);
  padding-bottom: 0rem;

  div {
    width: 300px;
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: 1023px) {
      width: 250px;
      justify-content: space-around;
    }
  }

  a {
    color: var(--color-primaryLightCompliment);
    font-size: 1.3rem;
    text-decoration: none;
    padding: 0.5rem;

    i.fa-search {
      color: var(--color-primaryCompliment);
      cursor: pointer;

      &:hover {
        color: var(--color-primaryCompliment);
      }
    }

    i {
      color: var(--color-secondary);
      font-size: 1.3rem;
    }

    &:hover {
      color: var(--color-primary);

      i {
        color: var(--color-primary);
      }
    }
  }
`

export const ColDiv = styled.div`
  max-width: 300px;
  height: 300px;
  display: flex;
  justify-content: space-evenly;
  flex-flow: column;
  margin: 0 auto;

  h1,
  h2 {
    margin: 0;
  }
  p {
    margin: 0;
    font-size: 1rem;
  }

  button {
    background-color: var(--color-secondary);
    padding: 0.8rem 2rem;
    font-family: 'Bungee';
    font-size: 1rem;
    border: none;
    cursor: pointer;
    color: #000;
  }
`
